module.exports = __webpack_public_path__ + "static/media/hero_alt.d87cbe17.svg";